import React from 'react';
import '../styles/Mantra.css'; // Mantra-specific styles

function Mantra({ backgroundImage, mantraText }) {
  return (
	<div className="mantra" style={{ backgroundImage: `url(${backgroundImage})` }}>
	  <div className="mantra-overlay">
		<div className="mantra-content">
		  <h1 className="mantra-text">{mantraText}</h1>
		</div>
	  </div>
	</div>
  );
}

export default Mantra;